/**
 * Ranking numbers composed from the 0-9 digit images (/top_games_digits/).
 * Each image is the old 275-unit square canvas with its glyph where a units digit sits,
 * so the units digit renders as before and the tens digit is the same image shifted left.
 */
const CANVAS = 275;

// Left/right glyph edge (outline included) of digits 0-9 on the canvas.
const GLYPH_LEFT = [138, 165, 135, 140, 137, 142, 141, 139, 140, 141];
const GLYPH_RIGHT = [265, 235, 263, 260, 266, 260, 262, 274, 263, 262];

/** Digits with their shift, and where the visible number starts — both as fractions of the image width. */
export const getTopGameNumberLayout = (rank: number) => {
  const units = rank % 10;
  if (rank < 10) return { digits: [{ digit: units, shift: 0 }], left: GLYPH_LEFT[units] / CANVAS };

  const tens = Math.floor(rank / 10) % 10;
  // the narrow "1" reads tighter, so it gets a wider gap
  const shift = (GLYPH_LEFT[units] - (tens === 1 ? 24 : 14) - GLYPH_RIGHT[tens]) / CANVAS;
  return {
    digits: [{ digit: tens, shift }, { digit: units, shift: 0 }],
    left: GLYPH_LEFT[tens] / CANVAS + shift,
  };
};
